<template>
  <div>
    <div class="header-wrap">
      <div class="header container rm-l-p rm-r-p">
        <router-link to="/">
        <div class="pull-left header-left">
          <a class="logo">
            <img src="../../../assets/img/logo.png" alt="一路牛" height="38">
          </a>
        </div>
        </router-link>
        <user-list/>
      </div>
    </div>
    <div class="headline-bg">
      <div id="waves" class="waves"></div>
    </div>
    <div class="container rm-l-p rm-r-p" id="contents" >
      <div id="main" class="main">
        <p class="close">
        </p>
        <div class="dashboard-func ">
          <div class="pull-left fill">
            <div class="app-fill">
              <span class="select" >个人中心</span>
            </div>
          </div>
        </div>
        <div>
          <section class="pull-left col-sm-10 profile-views">
            <div class="profile-title">
              <span class="profile-title-text fzlt">帐户资料</span>
            </div>
            <main class="profile-views-main-info">
              <div class="content-nav clearfix">
                <!--<span class="content-nav-item content-nav-item-select text-center pull-left">个人信息</span>-->
                <!--<span class="content-nav-item text-center pull-left">修改密码</span>-->
                <!--<span class="select-line"></span>-->
                <el-tabs v-model="activeName">
                  <el-tab-pane label="个人信息" name="first">
                    <div class="content-details info-conent clearfix">
                      <div class="info-show">
                        <div class="info-binding pull-left text-center">
                          <el-upload
                            class="avatar-uploader"
                            action="api/sysUser/uploadQinniu"
                            :headers="heads"
                            name="file"
                            :file-list="fileList"
                            :on-success="handleHeadSuccess"
                            :before-upload="beforeAvatarUpload"
                            :on-change="handleChange"
                            :on-error="uploadError">
                            <div class="info-avatar">
                              <img :src="userInfo.user.head" alt="用户头像" title="用户头像" width="120" height="120" class="img-circle user-avatar">
                              <div class="avatar-edit">
                                <img src="../../../assets/img/edit.svg" width="24" title="编辑头像" height="24" alt="编辑头像" class="edit-icon">
                              </div>
                              <div class="avatar-upload text-center">
                                <img style="vertical-align: middle; " src="../../../assets/img/camera.svg" width="46" height="35" alt="">
                                <span class="avatar-edit-tips">上传头像</span>
                              </div>
                            </div>
                            <div class="info-phone">已绑定手机：{{userInfo.user.phone}}<a href="/info/safe#bindingPhone" class="info-links ldms-font ldms-xiugai"></a></div>
                          </el-upload>
                        </div>
                        <div class="info-subjoin-item pull-left">
                          <p style="text-align: right">
                            <i v-if="isUpdate" class="ldms-font ldms-guanbi" style="cursor: pointer;position: absolute;z-index: 999;right: 30px" @click="isUpdate = false"></i>
                          </p>
                          <div class="info-item">
                            <div class="info-item-name">姓名: &nbsp;&nbsp;&nbsp;<input v-if="isUpdate" v-model="user.userName" placeholder="姓名"><span v-else class="user-name">{{userInfo.user.userName}}</span></div>
                          </div>
                          <div class="info-item">
                            <div class="info-item-name">邮箱: &nbsp;&nbsp;&nbsp;<input v-if="isUpdate" v-model="user.mail" placeholder="邮箱"><span v-else class="company-name">{{userInfo.user.mail}}</span></div>
                          </div>
                          <!--<div class="info-item">-->
                          <!--&lt;!&ndash;<div class="info-item-name">职务: &nbsp;&nbsp;&nbsp;<input placeholder="zhi"><span class="title">暂未填写</span></div>&ndash;&gt;-->
                          <!--</div>-->
                          <div class="info-save">
                            <button v-if="!isUpdate" class="btn btn-org-full info-submit-change" @click="update">更改</button>
                            <button v-if="isUpdate" class="btn btn-org-full info-submit-change" @click="updateUser">保存</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="修改密码" name="second">
                    <div class="content-details info-conent clearfix" style="width: 400px;margin: auto;">
                      <el-form :model="resetPasswordForm" status-icon :rules="resetPasswordRules" ref="resetPasswordForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="原密码" prop="oldPassword">
                          <el-input type="password" v-model="resetPasswordForm.oldPassword" placeholder="请输入原密码"></el-input>
                        </el-form-item>
                        <el-form-item label="新密码" prop="newPassword">
                          <el-input type="password" v-model="resetPasswordForm.newPassword" placeholder="请输入新密码" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="checkPass">
                          <el-input type="password" v-model="resetPasswordForm.checkPass" placeholder="请在输入一遍" auto-complete="off"></el-input>
                        </el-form-item>
                        <el-form-item>
                          <el-button type="primary" @click="resetPassword('resetPasswordForm')">提交</el-button>
                        </el-form-item>
                      </el-form>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </main>
          </section>
        </div>
    </div>
  </div>
  </div>
</template>
<script>
import userList from '../../layout/userList'
import { getToken } from 'util/auth'
import { update, resetPassword } from '../../../api/user'
import { mapGetters } from 'vuex'
export default {
  data: function () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.resetPasswordForm.checkPass !== '') {
          this.$refs.resetPasswordForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      resetPasswordForm: {
        checkPass: '',
        newPassword: '',
        oldPassword: ''
      },
      resetPasswordRules: {
        newPassword: [
          {validator: validatePass, trigger: 'blur'}
        ],
        checkPass: [
          {validator: validatePass2, trigger: 'blur'}
        ],
        oldPassword: [
          {required: true, message: '原密码不能为空', trigger: 'blur'}
        ]
      },
      activeName: 'first',
      fileList: [],
      heads: {},
      isUpdate: false,
      user: {
        userName: '',
        mail: ''
      }
    }
  },
  created () {
    this.heads = {'Authorization': 'bearer ' + getToken().accessToken}
  },
  computed: {
    ...mapGetters({userInfo: 'user/userInfo'})
  },
  methods: {
    handleHeadSuccess (response) {
      this.$store.dispatch('refreshUserToken')
      this.$message.success(response.msg)
    },
    uploadError () {
      this.$message.error('上传头像错误，请稍后重试')
    },
    handleChange (file, fileList) {
      this.fileList = fileList.slice(-1)
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    update () {
      this.user.userName = this.userInfo.user.userName
      this.user.mail = this.userInfo.user.mail
      this.isUpdate = true
    },
    updateUser () {
      let _this = this
      update(this.userInfo.user.userId, this.user).then(() => {
        _this.$store.dispatch('refreshUserToken')
      })
      this.isUpdate = false
    },
    resetPassword (formName) {
      let _this = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          resetPassword(this.userInfo.user.userId, this.resetPasswordForm).then((response) => {
            _this.$refs.resetPasswordForm.resetFields()
          }).catch(() => {
            _this.resetPasswordForm.checkPass = ''
          })
        } else {
          return false
        }
      })
    }
  },
  components: {
    userList
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .container
    .profile-views
      width 980px
      padding 35px
      background #FBFBFB
      border 1px solid #EEE
      box-shadow 0 0 5px 0 rgba(215,215,215,.5)
      .profile-title
        color #333
        letter-spacing -.63px
        font-size 24px
        line-height 24px
      .profile-views-main-info
        padding 44px 40px 0
        .content-nav
          position relative
          line-height 1
          .text-center
            cursor pointer
  .content-details
    position relative
  .info-conent
    padding-top 60px
    padding-bottom 70px
  .info-show
    position relative
  .info-binding
    border-right 1px dashed #ccc
    padding 30px 70px 70px 80px
    .info-phone
      padding-top: 12px
      font-size: 12px
      color: #999
      .info-links
        top: 3px
        margin-left: 5px
        color: #C2C2C2
        font-size 12px
    .info-avatar
      position: relative
      margin: 0 auto
      width: 120px
      height: 120px
      border-radius: 50%
      &:hover
        .avatar-upload
          opacity 1
      .avatar-edit
        top: 0
        border-radius: 50%
        border: 1px solid #ccc
        transform: rotate(45deg)
        transition: opacity .2s
        position: absolute
        width: 100%
        height: 100%
        left: 0
        .edit-icon
          position: absolute
          right: 0
          top: 50%
          margin-top: -12px
          margin-right: -12px
          transform: rotate(-45deg)
      .avatar-upload
        top: 0
        padding-top: 30px
        border-radius: 50%
        background-color: rgba(42,45,47,.8)
        cursor: pointer
        opacity 0
        transition: opacity .2s
        position: absolute
        width: 100%
        height: 100%
        left: 0
        .avatar-edit-tips
          display: block
          color: #fff
          line-height: 35px
      .img-circle
        border-radius: 50%
  .info-subjoin-item
    padding-left: 58px
    padding-top: 20px
    position: absolute
    right: 0
    width: 507px
    .info-item
      font-size: 16px
      color: #777
      padding-bottom: 30px
      display: block
      position: relative
      .info-item-name
        margin: 0
        font-weight: 300
        letter-spacing: 0
        font-size: 16px
        color: #777
        .user-name
          font-size: 16px
          scolor: #777
</style>
